<template>
    <div style="height: 100%">
        <div style="display: flex; width: 100%">
            <div style="width: 100%">
                <el-row class="filter-bar" ref="filterBar">
                    <el-select size="mini" v-model="formDatas.arfdFrom" clearable @change="partserch"
                        placeholder="请选择扣减渠道" style="width: 180px;">
                        <el-option label="系统" :value="1"></el-option>
                        <el-option label="易宝通" :value="2"></el-option>
                        <el-option label="河北小程序" :value="3"></el-option>
                        <!-- 4=内部商城(内部商城配套新增) -->
                        <el-option label="内部商城" :value="4"></el-option>
                    </el-select>
                    <el-input size="mini" v-model="formDatas.phone" clearable placeholder="请输入手机号"
                        style="width: 150px;" @keyup.enter.native="partserch"></el-input>
                    <el-input size="mini" v-model="formDatas.uniqueNum" clearable placeholder="请输入唯一凭证"
                        style="width: 180px;" @keyup.enter.native="partserch"></el-input>
                    <el-select size="mini" v-model="formDatas.arfdStatus" clearable @change="partserch"
                        placeholder="请选择状态" style="width: 130px;">
                        <el-option label="成功" :value="1"></el-option>
                        <el-option label="失败" :value="2"></el-option>
                        <!-- 3=未知:超时且反查不可用,巡检会定期定损 -->
                        <el-option label="未知" :value="3"></el-option>
                    </el-select>
                    <el-input size="mini" v-model="formDatas.specsSku" clearable placeholder="请输入商品编码"
                        style="width: 150px;" @keyup.enter.native="partserch"></el-input>
                    <el-input size="mini" v-model="formDatas.resultDeduct" clearable placeholder="扣减信息模糊搜索"
                        style="width: 150px;" @keyup.enter.native="partserch"></el-input>
                    <el-select size="mini" v-model="formDatas.arfdSyncEquityfee" clearable @change="partserch"
                        placeholder="是否同步" style="width: 130px;">
                        <el-option label="否" :value="1"></el-option>
                        <el-option label="是" :value="2"></el-option>
                    </el-select>
                    <div class="filter-actions">
          <el-button type="warning" size="mini" icon="el-icon-document-add" @click="handleRecover"
                        style="margin-right: 8px;">补建记录</el-button>
          <el-button type="info" size="mini" icon="el-icon-search" @click="partserch"
                        style="">搜索</el-button>
          </div>
        </el-row>
            </div>
        </div>
        <div class="tablemain">
            <div class="tablecss" v-loading="tableLoading" element-loading-background="rgba(255, 255, 255, 0.9)"
                element-loading-text="数据加载中..." element-loading-spinner="el-icon-loading" custom-class="table-loading">
                <div style="width: 100%">
                    <ve-table ref="vetable" v-if="tableData" :columns="columns" :table-data="tableData"
                        :max-height="tableHight" :border-x="true" :border-y="true" :scrollWidth="10"
                        :cell-style-option="cellStyleOption" style="width: 100%" />
                    <div v-show="tableData.length == 0" class="empty-data">暂无数据</div>
                </div>
                <div class="table-pagination">
                    <ve-pagination :total="totalCount" :page-index="formDatas.currentPage"
                        :page-size="formDatas.pageSize" :page-size-option="[10, 20, 40, 80, 160, 320, 640, 1000, 2000]"
                        @on-page-number-change="pageNumberChange" @on-page-size-change="pageSizeChange" />
                </div>
            </div>
            <!-- 回退弹框 -->
            <el-dialog title="系统操作回退(此功能会将权益金退回到用户账户,但不包括其他平台订单,请谨慎操作)" :visible.sync="dialogRollback" width="50%"
                :before-close="handleRollbackClose">
                <el-form :model="rollbackForm" label-width="100px">
                    <el-form-item label="回退原因">
                        <el-input type="textarea" v-model="rollbackForm.reason" placeholder="请输入回退原因"
                            :rows="4"></el-input>
                    </el-form-item>
                </el-form>
                <div slot="footer" class="dialog-footer">
                    <el-button @click="handleRollbackClose">取 消</el-button>
                    <el-button type="primary" @click="confirmRollback">确 定</el-button>
                </div>
            </el-dialog>
            <!-- 补建弹框:移动已扣款但扣减记录丢失(超时崩溃/无痕)时的处置入口 -->
            <el-dialog title="补建扣减记录(移动已实际扣款但记录丢失时使用;补建后请核对列表新增的「成功」行,再用「回退」把权益金退回用户)"
                :visible.sync="dialogRecover" width="55%" :before-close="handleRecoverClose">
                <el-form :model="recoverForm" label-width="110px">
                    <el-form-item label="手机号" required>
                        <el-input size="mini" v-model="recoverForm.phone" placeholder="用户手机号"
                            style="width: 300px;"></el-input>
                    </el-form-item>
                    <el-form-item label="唯一凭证">
                        <el-input size="mini" v-model="recoverForm.uniqueNum"
                            placeholder="内部商城AJ订单号;不确定可留空(自动取流水交易号)" style="width: 300px;"></el-input>
                    </el-form-item>
                    <el-form-item label="扣减渠道">
                        <el-select size="mini" v-model="recoverForm.arfdFrom" style="width: 300px;">
                            <el-option label="内部商城" :value="4"></el-option>
                            <el-option label="河北小程序(券码)" :value="3"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="移动流水JSON" required>
                        <el-input type="textarea" v-model="recoverForm.flowJson" :rows="8"
                            placeholder="在「权益金查询系统-流水记录」查到该用户 FLOWTYPE=Deduct 的那条流水,复制整条JSON粘贴至此"></el-input>
                    </el-form-item>
                </el-form>
                <div slot="footer" class="dialog-footer">
                    <el-button @click="handleRecoverClose">取 消</el-button>
                    <el-button type="warning" @click="confirmRecover">补 建</el-button>
                </div>
            </el-dialog>
        </div>
    </div>
</template>

<script>
import { calcTableHeight } from "../../utils/tableHeight.js";
import {
    getAjefRightsFundDeductList, updateAjefRightsFundDeductRollback, updateAjefRightsFundDeductRecover
} from "../../api/api";
export default {
    name: "",
    components: {},
    data() {
        return {
            dialogRollback: false,
            rollbackForm: {
                arfdId: null,
                reason: ''
            },
            currentRollbackRow: {},
            dialogRecover: false,
            recoverForm: {
                phone: '',
                uniqueNum: '',
                arfdFrom: 4,
                flowJson: ''
            },
            totalCount: 100,
            tableLoading: false,
            tableHight: 520,
            cellStyleOption: {
                headerCellClass: ({ column, rowIndex }) => {
                    if (rowIndex === 0) {
                        return "table-header-cell-class";
                    }
                },
            },
            columns: [
                {
                    field: "",
                    key: "a",
                    title: "序号",
                    width: 50,
                    fixed: 'left',
                    align: "center",
                    renderBodyCell: ({ row, column, rowIndex }, h) => {
                        return ++rowIndex;
                    },
                },
                {
                    field: "arfdFrom",
                    key: "arfdFrom",
                    title: "扣减渠道",
                    align: "center",
                    width: 100,
                    renderBodyCell: ({ row, column, rowIndex }, h) => {
                        // 扣减渠道:1系统 2易宝通 3河北小程序 4内部商城
                        return row.arfdFrom == 1 ? '系统' : row.arfdFrom == 2 ? '易宝通' : row.arfdFrom == 4 ? '内部商城' : '河北小程序';
                    },
                },
                {
                    field: "uniqueNum",
                    key: "uniqueNum",
                    title: "唯一凭证",
                    align: "center",
                    width: 200,
                },
                {
                    field: "phone",
                    key: "phone",
                    title: "手机号",
                    align: "center",
                    width: 120,
                },
                {
                    field: "amount",
                    key: "amount",
                    title: "金额(分)",
                    align: "center",
                    width: 100,
                },
                {
                    field: "resultDeduct",
                    key: "resultDeduct",
                    title: "移动侧扣减信息",
                    align: "center",
                    width: 250,
                },
                {
                    field: "arfdStatus",
                    key: "arfdStatus",
                    title: "状态",
                    align: "center",
                    width: 80,
                    renderBodyCell: ({ row, column, rowIndex }, h) => {
                        // 1成功 2失败 3未知(超时且反查不可用,巡检定期定损)
                        return row.arfdStatus == 1 ? <el-tag type="success">成功</el-tag> :
                            row.arfdStatus == 3 ? <el-tag type="warning">未知</el-tag> : <el-tag type="danger">失败</el-tag>;
                    },
                },
                { field: "specsSku", key: "specsSku", title: "商品编码", width: 150, align: "center" },
                { field: "specsName", key: "specsName", title: "商品名称", width: 150, align: "center" },
                {
                    field: "arfdSyncEquityfee",
                    key: "arfdSyncEquityfee",
                    title: "是否同步",
                    align: "center",
                    width: 90,
                    renderBodyCell: ({ row, column, rowIndex }, h) => {
                        return row.arfdSyncEquityfee == 1 ? '否' : row.arfdSyncEquityfee == 2 ? '是' : '-';
                    },
                },
                { field: "createtime", key: "createtime", title: "创建时间", width: 160, align: "center" },
                { field: "createusername", key: "createusername", title: "创建人", width: 100, align: "center" },
                {
                    field: "",
                    key: "d",
                    title: "操作",
                    width: 100,
                    align: "center",
                    fixed: "right",
                    renderBodyCell: ({ row, column, rowIndex }, h) => {
                        return (
                            <span>
                                <el-button
                                    size="mini"
                                    type="text"
                                    style="color: #E6A23C"
                                    on-click={() => {
                                        this.handleRollback(row);
                                    }}
                                >
                                    回退
                                </el-button>
                            </span>
                        );
                    },
                },
            ],
            tableData: [],
            formDatas: {
                currentPage: 1,
                pageSize: 10,
            },
        };
    },
    activated() {
        this.$nextTick(() => {
            this.tableHight = this.$store.state.windheight - 200 - this.$store.state.windheight * 0.04;
        });
    },
    watch: {
        "$store.state.windheight"(val) {
            this.$nextTick(() => {
                this.tableHight = calcTableHeight(this, val, 140);
            });
        },
    },
    deactivated() { },
    created() {
        this.tableHight = this.$store.state.windheight - 200 - this.$store.state.windheight * 0.04;
        this.getList();
    },
    mounted() { },
    methods: {
        handleRecover() {
            this.recoverForm = { phone: '', uniqueNum: '', arfdFrom: 4, flowJson: '' };
            this.dialogRecover = true;
        },
        handleRecoverClose() {
            this.dialogRecover = false;
        },
        confirmRecover() {
            if (!this.recoverForm.phone || !this.recoverForm.flowJson) {
                this.$message({ type: 'warning', message: '请填写手机号和移动流水JSON' });
                return;
            }
            let flow = null;
            try {
                flow = JSON.parse(this.recoverForm.flowJson);
            } catch (e) {
                flow = null;
            }
            if (!flow || !flow.TRANSIDO || !flow.SUBTRANIDO || !flow.RECFORMNUM || !flow.FLOWAMT) {
                this.$message({ type: 'warning', message: '流水JSON不完整(需含TRANSIDO/SUBTRANIDO/RECFORMNUM/FLOWAMT),请粘贴整条流水' });
                return;
            }
            if (flow.FLOWTYPE !== 'Deduct') {
                this.$message({ type: 'warning', message: '该流水不是扣减流水(FLOWTYPE需为Deduct),请勿误用充值/回退流水' });
                return;
            }
            const msg = `
                <div style="text-align: left; padding: 10px 0;">
                    <p><strong>手机号：</strong>${this.recoverForm.phone}</p>
                    <p><strong>扣减金额：</strong>${flow.FLOWAMT}(分)</p>
                    <p><strong>移动交易号：</strong>${flow.TRANSIDO}</p>
                    <p><strong>流水时间：</strong>${flow.FLOWDATE || '-'}</p>
                    <p style="color: #E6A23C;">补建后将新增一条"成功"扣减记录,请核对后再用「回退」退款,回退只可操作一次</p>
                </div>
            `;
            this.$confirm(msg, '确认补建扣减记录', {
                confirmButtonText: '确认补建',
                cancelButtonText: '取消',
                type: 'warning',
                dangerouslyUseHTMLString: true
            }).then(() => {
                this.openLoading();
                updateAjefRightsFundDeductRecover({
                    phone: this.recoverForm.phone,
                    uniqueNum: this.recoverForm.uniqueNum,
                    arfdFrom: this.recoverForm.arfdFrom,
                    flowJson: this.recoverForm.flowJson,
                    operatorName: localStorage.getItem("Qy_userName") || ''
                }).then((res) => {
                    this.loadings.close();
                    if (res.data) {
                        this.$message({
                            type: 'success',
                            message: '补建成功:请核对列表新增的"成功"记录,然后用「回退」将权益金退回用户'
                        });
                        this.handleRecoverClose();
                        this.getList();
                    }
                }).catch(() => {
                    this.loadings.close();
                });
            }).catch(() => { });
        },
        handleRollback(row) {
            this.rollbackForm.arfdId = row.arfdId;
            this.rollbackForm.reason = '';
            this.currentRollbackRow = row;
            this.dialogRollback = true;
        },
        handleRollbackClose() {
            this.dialogRollback = false;
            this.rollbackForm = {
                arfdId: null,
                reason: ''
            };
            this.currentRollbackRow = {};
        },
        confirmRollback() {
            if (!this.rollbackForm.reason) {
                this.$message({
                    type: 'warning',
                    message: '请输入回退原因'
                });
                return;
            }
            const row = this.currentRollbackRow;
            const msg = `
                <div style="text-align: left; padding: 10px 0;">
                    <p><strong>手机号：</strong>${row.phone || '-'}</p>
                    <p><strong>金额：</strong>${row.amount || '-'}(分)</p>
                    <p><strong>唯一凭证：</strong>${row.uniqueNum || '-'}</p>
                    <p><strong>回退原因：</strong>${this.rollbackForm.reason}</p>
                </div>
            `;
            this.$confirm(msg, '确认回退操作', {
                confirmButtonText: '确定回退',
                cancelButtonText: '取消',
                type: 'warning',
                dangerouslyUseHTMLString: true
            }).then(() => {
                this.openLoading();
                updateAjefRightsFundDeductRollback(this.rollbackForm).then((res) => {
                    this.loadings.close();
                    if (res.data) {
                        this.$message({
                            type: 'success',
                            message: '操作成功'
                        });
                        this.handleRollbackClose();
                        this.getList();
                    }
                }).catch(() => {
                    this.loadings.close();
                });
            }).catch(() => { });
        },
        openLoading() {
            this.loadings = this.$loading({
                lock: true,
                text: "加载中...",
                spinner: "el-icon-loading",
                background: "rgba(0, 0, 0, 0.7)"
            });
        },
        pageSizeChange(pageSize) {
            this.formDatas.pageSize = pageSize;
            this.partserch();
        },
        pageNumberChange(pageIndex) {
            this.formDatas.currentPage = pageIndex;
            this.tableLoading = true;
            getAjefRightsFundDeductList(this.formDatas).then((res) => {
                this.tableLoading = false;
                this.tableData = res.data;
                this.totalCount = res.total;
            }).catch(() => {
                this.tableLoading = false;
            });
        },
        partserch() {
            this.formDatas.currentPage = 1;
            this.tableLoading = true;
            getAjefRightsFundDeductList(this.formDatas).then((res) => {
                this.tableLoading = false;
                this.tableData = res.data;
                this.totalCount = res.total;
            }).catch(() => {
                this.tableLoading = false;
            });
        },
        getList() {
            this.tableLoading = true;
            getAjefRightsFundDeductList(this.formDatas).then((res) => {
                this.tableLoading = false;
                this.tableData = res.data;
                this.totalCount = res.total;
            }).catch(() => {
                this.tableLoading = false;
            });
        },
    },
};
</script>

<style>
.table-header-cell-class {
    background: var(--bg-color) !important;
    color: var(--font-color) !important;
    border-right: 0px !important;
}

.easetable::-webkit-scrollbar {
    display: none;
}

.ve-table-container {
    height: auto !important;
}
</style>
